/** Eternal City copy, it. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityIt: Record<string, string> = {
  'city.seoDescription': 'Entrate in una città vivente. Tutti seguono una routine quotidiana. Seguiteli, parlate con loro, e trascorrete un giorno con le persone che vivono senza di voi.',
  'city.intro': 'Una città viva, tutti qui hanno una routine quotidiana e il tempo passa mentre giochi.',
  'city.back': 'Torniamo al globo',
  'city.connecting': 'Aprire i cancelli della città...',
  'city.reconnecting': 'Ho perso il filo.',
  'city.offline': 'La citta\' e\' fuori portata, per favore, riprova tra un po\'.',
  'city.signinTitle': 'Inserire per entrare',
  'city.signinBody': 'Il tuo posto in città, il tuo diario e le persone che hai incontrato sono salvati per il tuo conto.',
  'city.signinCta': 'Accedi',
  'city.privacy': 'Come gestiamo questi dati: Politica sulla privacy',
  'city.blocked': 'La città non ha accesso a questo account in questo momento, se pensate che sia un errore, contattate il supporto.',
  'city.openElsewhere': 'Questa citta\' e\' aperta in un\'altra scheda.',
  'city.canvasLabel': 'Mappa isometrica di {city}. Usa le liste accanto a essa per parlare, camminare e guardare intorno.',
  'city.hint': 'Fai clic sul terreno per camminare, o fai clic su una persona per parlare.',
  'city.holiday': 'Oggi: {name}',
  'city.here': 'Sei al {place}.',
  'city.commons.empty': 'Questo e\' uno spazio condiviso, e nessun altro viaggiatore e\' qui in questo momento.',
  'city.commons.here.one': 'Questo e\' uno spazio condiviso, e un altro viaggiatore e\' qui.',
  'city.commons.here.other': 'Questo è uno spazio condiviso, e... {count} Altri viaggiatori sono qui.',
  'city.commons.peer': 'un compagno di viaggio',
  'city.crowd.name': 'Cittadino',
  'city.travel.ride': 'Ride to {place} (circa {n} minuti)',
  'city.wares.now': 'Ora è chiaro: {list}',
  'city.wares.none': 'Non c\' è niente a quest\' ora .',
  'city.wares.few': '{name} (alcuni a sinistra)',
  'city.wares.last': '{name} (l\' ultimo)',
  'city.places': 'Vai da qualche parte .',
  'city.goPlace': 'Vai a {place}',
  'city.dialogueAnnounce': 'Le scelte vengono annunciate come appaiono.',
  'city.people': 'Chi c\'è in giro ?',
  'city.peopleNone': 'Nessuno in vista.',
  'city.talk': 'Parla',
  'city.goto': 'Passeggiate.',
  'city.away': '{n} passi lontano',
  'city.scenes': 'Sta succedendo nelle vicinanze.',
  'city.watch': 'Partecipate.',
  'city.props': 'Guardate intorno .',
  'city.examine': 'Guardate.',
  'city.open': 'Apri',
  'city.take': 'Prendila.',
  'city.menu.open': 'Apri {thing}',
  'city.menu.take': 'Prendi quello che c\'è dentro. {thing}',
  'city.menu.walkToThing': 'Passeggiate . {thing}',
  'city.dialogue': 'Conversazione',
  'city.close': 'Chiuso',
  'city.leave': 'Lascia la conversazione',
  'city.menu.talk': 'Parla con {name}',
  'city.menu.walkTalk': 'Passeggiate verso di me. {name}',
  'city.menu.walkTo': 'Passeggiate . {name}',
  'city.menu.walkHere': 'Cammina qui.',
  'city.menu.swimHere': 'Nuotate qui.',
  'city.menu.rowHere': '- Fate una fila qui.',
  'city.mount.down': 'Scendi da qui. {name}',
  'city.companion.home': 'Inviare {name} casa',
  'city.rumours.title': 'Tavola dei rumori',
  'city.rumours.none': 'Sono vicini ai cittadini che parlano insieme, soprattutto alla taverna, e quello che dicono è fissato qui.',
  'city.rumours.said': 'Ha detto {name}',
  'city.greet.title': 'Conosciuto per nome',
  'city.greet.callMe': 'Come ti chiamano i cittadini',
  'city.greet.placeholder': 'Il tuo nome.',
  'city.greet.none': 'Basta parlare con qualcuno, e la prossima volta ti saluteranno per nome.',
  'city.greet.morning.0': 'Domattina. {name}!',
  'city.greet.morning.1': 'Buongiorno a te. {name}.',
  'city.greet.morning.2': 'Alzati presto. {name}?',
  'city.greet.afternoon.0': 'Buongiorno. {name}.',
  'city.greet.afternoon.1': 'Buongiorno. {name}!',
  'city.greet.afternoon.2': 'Bene, ci vediamo di nuovo. {name}.',
  'city.greet.evening.0': 'La sera, {name}.',
  'city.greet.evening.1': 'Buonasera. {name}!',
  'city.greet.evening.2': 'Fuori da casa. {name}?',
  'city.greet.night.0': 'E\' tardi per uscire. {name}.',
  'city.greet.night.1': 'Attenzione al buio. {name}.',
  'city.greet.night.2': 'Ancora in giro, {name}?',
  'city.greet.morning.0.anon': 'Buongiorno, amico!',
  'city.greet.morning.1.anon': 'Buongiorno a voi.',
  'city.greet.morning.2.anon': 'Sei sveglio presto, amico?',
  'city.greet.afternoon.0.anon': 'Buongiorno, amico.',
  'city.greet.afternoon.1.anon': 'Buona giornata!',
  'city.greet.afternoon.2.anon': 'Benvenuto di nuovo.',
  'city.greet.evening.0.anon': 'sera, amico.',
  'city.greet.evening.1.anon': 'Buonasera!',
  'city.greet.evening.2.anon': 'Fuori da casa, amico?',
  'city.greet.night.0.anon': 'E\' tardi per uscire, amico.',
  'city.greet.night.1.anon': 'Attenzione al buio.',
  'city.greet.night.2.anon': 'Ancora in giro, amico?',
  'city.market.title': 'Tavola di mercato',
  'city.market.shut': 'Non c\'e\' niente in programma adesso.',
  'city.market.later': 'Più tardi oggi:',
  'city.market.am': '{n} al mattino',
  'city.market.pm': '{n} nel pomeriggio',
  'city.market.eve': '{n} alla sera',
  'city.garden.title': 'Piantagioni giardini',
  'city.garden.tend': 'La trama è finita.',
  'city.garden.tended': 'Tirate un po\' di erbacce e annaffiate la trama.',
  'city.garden.already': 'Hai gia\' curato questa trama oggi.',
  'city.garden.tendedNote': 'oggi',
  'city.garden.arrive': 'La {crop} Eccoli. {stage}.',
  'city.garden.crop.herbs': 'erbe',
  'city.garden.crop.apples': 'alberi di mele',
  'city.garden.crop.kitchen': 'vegetale da cucina',
  'city.garden.crop.cabbages': 'alcolici e fagioli',
  'city.garden.crop.wheat': 'campi di grano',
  'city.garden.stage.bare': 'nudi per l\'inverno',
  'city.garden.stage.sown': 'piantate appena piantate',
  'city.garden.stage.sprouting': 'germogliamento',
  'city.garden.stage.growing': 'crescendo bene',
  'city.garden.stage.flowering': 'in fiore',
  'city.garden.stage.ripe': 'matura e pronta',
  'city.garden.stage.harvested': 'raccolto per l\'anno',
  'city.fish.title': 'Pesca',
  'city.fish.cast': 'Fai una linea .',
  'city.fish.go': '- Va\' via.',
  'city.fish.here': 'Un buon posto per la pesca.',
  'city.fish.casting': 'Tu fai una fila e aspetti.',
  'city.fish.caught': 'Qualcosa morde. {fish}.',
  'city.fish.got.boot': 'Si rimorchia in un vecchio stivale e lo si rimorchia.',
  'city.fish.got.weed': 'Solo erba del fiume questa volta.',
  'city.fish.got.nothing': 'L\'acqua conserva i suoi segreti.',
  'city.fish.casts': '{n} lanci fino ad ora',
  'city.fish.none': 'I pesci mordono meglio all\'alba e al tramonto, e di piu\' in primavera e autunno.',
  'city.fish.spot.bank': 'riva del fiume',
  'city.fish.spot.jetty': 'giardino',
  'city.fish.spot.bridge': 'ponte di mulino',
  'city.fish.name.perch': 'un perco',
  'city.fish.name.roach': 'un scarafaggio',
  'city.fish.name.trout': 'una trota',
  'city.fish.name.eel': 'un\'anguilla',
  'city.fish.name.pike': 'un picco',
  'city.fish.name.carp': 'una carpa',
  'city.fish.name.minnow': 'un minnow',
  'city.fish.name.crayfish': 'un granchio',
  'city.fish.name.boot': 'una vecchia scarpa',
  'city.fish.name.weed': 'erba del fiume',
  'city.fish.name.nothing': 'Niente',
  'city.lost.title': 'Perduto e trovato',
  'city.lost.none': 'I cittadini lasciano le cose nei mercati, nella piazza e in altri luoghi affollati.',
  'city.lost.whose': 'appartiene a {name}',
  'city.lost.find': 'Trova {name}',
  'city.lost.spot': 'C\' e \' qualcosa sulla terra qui: {thing}',
  'city.lost.pick': 'Raccogli. {thing}',
  'city.lost.picked': 'Raccogli tu . {thing}. Sembra che appartenga a {name}.',
  'city.lost.give': 'Dare {thing} di nuovo a {name}',
  'city.lost.thanks': '{name} E\' felice di avere {thing} Torna indietro.',
  'city.lost.thing.glove': 'un guanto perso',
  'city.lost.thing.keys': 'un anello di chiavi',
  'city.lost.thing.locket': 'un piccolo medaglione',
  'city.lost.thing.toy': 'un giocattolo di legno',
  'city.lost.thing.scarf': 'una sciarpa di lana',
  'city.lost.thing.purse': 'una borsa vuota',
  'city.lost.thing.spectacles': 'un paio di occhiali',
  'city.lost.thing.letter': 'una lettera piegata',
  'city.lost.thing.ribbon': 'un nastro per capelli',
  'city.lost.thing.pipe': 'un tubo di argilla',
  'city.records.title': 'Registri della città',
  'city.records.peak': 'Il giorno piu\' impegnato {time}, con {n} Gli abitanti della citta\' fuori e intorno.',
  'city.records.now': 'A quest\' ora: {out} fuori. {home} a casa.',
  'city.records.busiest': 'Quartiere più trafficato: {district}.',
  'city.records.outTitle': 'I cittadini fuori, per ora.',
  'city.records.seenTitle': 'Le persone che hai visto intorno a te, per ora',
  'city.a11y.title': 'Accessibilità',
  'city.a11y.text': 'Dimensione del testo',
  'city.a11y.size1': 'Normalmente',
  'city.a11y.size125': 'Grandi',
  'city.a11y.size15': 'Il più grande',
  'city.a11y.stillOff': 'Riduzione del movimento',
  'city.a11y.stillOn': 'Riduzione della mozione',
  'city.a11y.contrastOff': 'Alto contrasto',
  'city.a11y.contrastOn': 'Alti contrasti',
  'city.tour.welcome.title': 'Benvenuti a {city}',
  'city.tour.welcome.body': 'Questa città vive su un suo orologio. La gente si sveglia, lavora, mangia e dorme, che tu guardi o no. Ecco un breve sguardo intorno.',
  'city.tour.walk.title': 'Camminare',
  'city.tour.walk.body': 'Appuntate su qualsiasi terreno aperto per camminare, il vostro robot troverà la sua strada intorno alle pareti e attraverso le porte.',
  'city.tour.talk.title': 'Parlando',
  'city.tour.talk.body': 'Tocca una persona per vedere il suo nome e avvicinarti. Una volta che sei vicino, tocca di nuovo per parlare.',
  'city.tour.menu.title': 'Guardando da vicino',
  'city.tour.menu.body': 'Su un computer, fai clic destro su qualsiasi cosa per vedere cosa puoi fare lì, come leggere un cartello, sederti o prendere una stanza.',
  'city.tour.map.title': 'La minima mappa',
  'city.tour.map.body': 'La piccola mappa nell\'angolo mostra strade, quartieri e persone vicine a voi.',
  'city.tour.panel.title': 'Il tuo pannello',
  'city.tour.panel.body': 'Il pannello laterale elenca le persone nelle vicinanze, i luoghi che hai scoperto, le tue missioni, il tuo diario e altro ancora.',
  'city.tour.keys.title': 'Movimenti',
  'city.tour.keys.body': 'Il pulsante della tastiera mostra ogni mossa che il robot conosce.',
  'city.tour.done.title': 'E \' tutto .',
  'city.tour.done.body': 'Godetevi {city}. Puoi fare questo tour di nuovo dal pannello laterale.',
  'city.tour.step': '{n} di {total}',
  'city.tour.next': 'Il prossimo .',
  'city.tour.back': 'Torna indietro',
  'city.tour.skip': 'Salta il tour.',
  'city.tour.finish': 'Inizia a esplorare',
  'city.tour.again': 'Torna a visitare la città .',
  'city.found.title': 'Luoghi scoperti',
  'city.found.count': '{n} di {total}',
  'city.found.none': 'Andate in un posto per aggiungerla qui.',
  'city.found.new': 'Scoperto {place}',
  'city.board.open': 'Leggi il tabellone pubblico di appunti',
  'city.board.hint': 'Le note lasciate qui da altri viaggiatori, un breve di voi, senza collegamenti, e fino a tre di voi rimangono al tempo stesso.',
  'city.board.placeholder': 'Scrivi una breve nota per essere trovata da altri',
  'city.board.pin': 'Accoppiate il biglietto .',
  'city.board.loading': 'Leggendo la lavagna...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Scarica il tuo biglietto .',
  'city.board.err.signin': 'Accedi per inserire un biglietto.',
  'city.board.err.soon': 'Aspetta un po\' prima di mettere un altro biglietto.',
  'city.board.err.bad': 'Le note devono essere di testo semplice fino a 200 caratteri, senza collegamenti.',
  'city.board.err.down': 'Non si puo\' contattare il consiglio in questo momento.',
  'city.room.rent': 'Prendi una stanza a {place}',
  'city.room.move': 'Trasferisci la tua stanza in {place}',
  'city.room.yours': 'La tua stanza al {place}',
  'city.room.decorate': 'Metti qualcosa qui.',
  'city.room.remove': 'Togliete la {thing}',
  'city.room.leave': 'Dedicate la vostra stanza .',
  'city.room.full': 'La tua stanza non ha spazio per altro.',
  'city.room.pickTitle': 'Arredate la vostra stanza .',
  'city.room.pickHint': 'Scegli qualcosa da impostare in questo punto, rimane nella tua stanza su questo dispositivo.',
  'city.room.kind.rug': 'Un tappeto tessuto',
  'city.room.kind.candle': 'Una candela',
  'city.room.kind.flowers': 'Un vaso di fiori',
  'city.room.kind.painting': 'Un dipinto',
  'city.room.kind.plant': 'Una pianta in vaso',
  'city.room.kind.chest': 'Un piccolo petto .',
  'city.room.kind.lantern': 'Una lanterna',
  'city.room.kind.books': 'Un paio di libri.',
  'city.busk.lute': '{name} prende una melodia brillante vicino',
  'city.busk.fiddle': '{name} si segga un rulli animato nelle vicinanze',
  'city.busk.pipe': '{name} suona un aria lenta vicino',
  'city.busk.drum': '{name} batte fuori una danza nelle vicinanze',
  'city.tail.label': 'Seguire {name}',
  'city.tail.title': 'Sulla coda {name} durante tutto il giorno',
  'city.tail.now': 'Ora: {activity} in {place}',
  'city.tail.unknown': 'I loro piani per ora sono sconosciuti.',
  'city.tail.next': 'Prossimo: {place} a {time}, in {h} h {m} min',
  'city.tail.trail': 'Tracciato: {places}',
  'city.tail.stop': 'Smettila di seguirmi.',
  'city.pins.add': 'Aggiungere un pin',
  'city.pins.tapMap': 'Toccare la mappa per posizionare la tua pin',
  'city.pins.walk': 'Cammina da questa spina.',
  'city.pins.note': 'Pin a {x}, {y}. Aggiungi una nota',
  'city.pins.noteLabel': 'Nota di pin',
  'city.pins.remove': 'Togliete questo pin',
  'city.pins.here': 'Pin questo punto sulla mappa',
  'city.compass.north': 'Nord',
  'city.compass.at': 'X {x}, y {y}, piano {floor}',
  'city.door.prop': 'Appoggi la porta aperta',
  'city.door.close': 'Lascia chiudere la porta',
  'city.door.unlock': 'Sblocca la porta .',
  'city.door.lock': 'Chiudi la porta.',
  'city.books.browse': 'Scorrere lo scaffale',
  'city.books.shelf': 'Reggia al {place}',
  'city.books.book': 'Libro',
  'city.books.scroll': 'Scandalo',
  'city.books.prev': 'Precedenti',
  'city.books.back': 'Torna sullo scaffale .',
  'city.books.next': 'Il prossimo .',
  'city.books.page': 'Pagina {n} di {of}',
  'city.sign.readSign': 'Leggi il cartello.',
  'city.sign.readPlaque': 'Leggi la targa',
  'city.sign.sign': 'Un cartello dipinto',
  'city.sign.plaque': 'Una targa vicino alla porta',
  'city.district.entering': 'Ora entrando',
  'city.district.riverside': 'La riva del fiume e i mercati bassi',
  'city.district.sunwalk': 'Sunwalk',
  'city.district.lanes': 'Le corsie',
  'city.district.monastery': 'Il monastero',
  'city.district.castle': 'Il Castello',
  'city.district.drains': 'Le vecchie scariche',
  'city.district.farmlands': 'Le terre agricole',
  'city.photo.enter': 'Modalità fotografica',
  'city.photo.hint': 'La modalità foto: trascinate per guardare intorno, fate uno screenshot per tenerlo.',
  'city.photo.leave': 'Lasciare la modalità foto',
  'city.building.who': 'Che vive e lavora al {place}',
  'city.building.live': 'Vive qui.',
  'city.building.work': 'Qui funziona .',
  'city.building.now': 'All\' interno , ora .',
  'city.building.rooms': 'Si accende {list}.',
  'city.inspect.about': 'In merito {name}',
  'city.inspect.close': 'Chiuso',
  'city.inspect.unknown': 'Nessuno può dirti molto {name}.',
  'city.inspect.home': 'Casa',
  'city.inspect.work': 'Lavoro',
  'city.inspect.none': 'Nessuno conosciuto',
  'city.inspect.today': 'Oggi',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Segui {name} durante tutto il giorno',
  'city.overlay.label': 'Superiori di mappe',
  'city.overlay.crowd': 'Molte persone',
  'city.overlay.light': 'Luce',
  'city.overlay.noise': 'Rumore',
  'city.bar.pop': '{n} Vivi qui.',
  'city.bar.out': '{n} Ora fuori.',
  'city.bar.season.spring': 'Primavera',
  'city.bar.season.summer': 'L\'estate',
  'city.bar.season.autumn': 'Autunno',
  'city.bar.season.winter': 'Inverno',
  'city.notebook.title': 'Ho sentito e imparato',
  'city.notebook.all': 'Tutti .',
  'city.notebook.heard': 'Ho sentito .',
  'city.notebook.learned': 'Imparato',
  'city.notebook.search': 'Cerca le tue note',
  'city.notebook.none': 'Ascolta per strada e parla con la gente.',
  'city.ask.title': 'Chiedi intorno.',
  'city.ask.pick': '- Chi cerchi?',
  'city.ask.ask': 'Chiedete',
  'city.ask.passerby': 'Un passante',
  'city.ask.nobody': 'Non c\'è nessuno abbastanza vicino da chiederlo.',
  'city.ask.unseen': '{asker} non ha visto {who} circa oggi.',
  'city.ask.here': '{asker} dice {who} è vicino. {place}.',
  'city.ask.go': 'Vai a {who}',
  'city.weather.clear': 'Cielo limpido',
  'city.weather.cloudy.light': 'Un po\' di nuvole.',
  'city.weather.cloudy.heavy': 'Grigio e nuvoloso',
  'city.weather.rain.light': 'Pioggia leggera',
  'city.weather.rain.heavy': 'Pioggia intensa',
  'city.weather.fog.light': 'Nebbia mattutina',
  'city.weather.fog.heavy': 'Nebbia spessa',
  'city.weather.snow.light': 'Neve leggera',
  'city.weather.snow.heavy': 'Neve pesante',
  'city.lamplighter.name': 'Luminatore',
  'city.lamplighter.lighting': 'accendere le lampade di strada',
  'city.lamplighter.dousing': 'spegnere le lampade di strada',
  'city.hourglass.title': 'Orologio di sabbia',
  'city.hourglass.stop': 'Ferma la giornata',
  'city.hourglass.paused': 'Il giorno è fermo.',
  'city.hourglass.resume': '- Andiamo.',
  'city.seat.bench': 'bancone',
  'city.seat.chair': 'sedile',
  'city.seat.sit': 'Siediti sul {what}',
  'city.inside.crate': 'cassa',
  'city.inside.barrel': 'Baril',
  'city.inside.title': 'All\'interno del {what}',
  'city.inside.look': 'Guarda dentro. {what}',
  'city.inside.holds': 'E\' {fill}: {list}.',
  'city.factions.title': 'In piedi in città',
  'city.factions.wary': 'Attenzione .',
  'city.factions.unknown': 'Non conosciuto',
  'city.factions.noticed': 'Notato',
  'city.factions.trusted': 'Fiduciato',
  'city.factions.honored': 'Onorato',
  'city.factions.done': 'Rendi compiuti: {n}.',
  'city.mail.title': 'Lettere',
  'city.mail.none': 'Non ci sono ancora lettere.',
  'city.mail.from': 'Da: {name}',
  'city.mail.waiting': 'In attesa di una risposta da parte di {names}.',
  'city.mail.nobody': 'Aiuta qualcuno con un compito e puoi scrivergli.',
  'city.mail.write': 'Scrivi una lettera.',
  'city.mail.to': 'A chi',
  'city.mail.subject': 'soggetto',
  'city.mail.body': 'La tua lettera',
  'city.mail.send': 'Mandalo .',
  'city.mail.untitled': 'Un paio di righe .',
  'city.moth.title': 'Il vassoio della farfalla',
  'city.moth.trade': 'Fateci un favore .',
  'city.moth.yours': 'Ora è tuo.',
  'city.spy.title': 'Lavorare in silenzio',
  'city.cut.skip': 'Skip',
  'city.party.title': 'Giocate insieme .',
  'city.party.blurb': 'Iniziate una festa e condividete il suo codice con gli amici.',
  'city.party.start': 'Inizia una festa .',
  'city.party.codeLabel': 'Codice del partito',
  'city.party.join': 'Unisciti',
  'city.party.bad': 'Il codice di un partito e\' composto da quattro o otto lettere o numeri.',
  'city.party.code': 'Il tuo codice di festa è: {code}. - Condividilo con gli amici, cosi\' possono unirsi.',
  'city.party.alone': 'Nessun altro della tua festa è in città in questo momento.',
  'city.party.here': 'Proprio accanto a te',
  'city.party.away': '{n} Pace {dir}',
  'city.party.floor': '(piano {n})',
  'city.party.go': 'Vai a',
  'city.party.leave': 'Lascia la festa.',
  'city.party.dir.east': 'est',
  'city.party.dir.south-east': 'sud-est',
  'city.party.dir.south': 'sud',
  'city.party.dir.south-west': 'sud-ovest',
  'city.party.dir.west': 'Occidente',
  'city.party.dir.north-west': 'nord-ovest',
  'city.party.dir.north': 'Nord',
  'city.party.dir.north-east': 'nord-est',
  'city.print.title': 'Stampa un edificio',
  'city.print.here': '{name}: {w} per {d} cellule, pavimenti: {n}. Salva come STL per una stampante 3D.',
  'city.print.none': 'Stare dentro o accanto a un edificio per salvarlo come STL per una stampante 3D.',
  'city.print.model': 'Salvo STL, scala modello (5 mm per cella)',
  'city.print.tabletop': 'Salvare STL, scala di tavolo (1 pollice a cella)',
  'city.print.note': 'Muri, pavimenti, porte, scale e finestre mentre la città li disegna, su una piastra base in modo da stampare in un pezzo.',
  'city.print.models': 'Figura e accessori, pronti per la stampa:',
  'city.print.busy': 'Preparando...',
  'city.print.model.figure': 'Figura di Walker, 28 mm su una base di 25 mm',
  'city.print.model.fountain': 'Fontana, 3 pollici di diametro',
  'city.print.model.castle-wall': 'Sezione della parete del castello, lunga 3 pollici',
  'city.editor.stl': 'Salvare STL',
  'city.editor.title': 'Editore di mappe della città',
  'city.editor.blurb': 'Dipingere una mappa della città piano per piano: pareti, strade, porte, acqua, scale e luoghi nominati. Il controllo di seguito la legge con lo stesso lettore di mappa che la città vivente utilizza. Il tuo disegno salva in questo browser; esportarlo come un file da conservare o condividere.',
  'city.editor.name': 'Nome della mappa',
  'city.editor.tools': 'Strumenti',
  'city.editor.tool.pen': 'Penna',
  'city.editor.tool.rect': 'Blocco',
  'city.editor.tool.room': 'Camera',
  'city.editor.tool.fill': 'Riempire',
  'city.editor.tool.spawn': 'Punto di partenza',
  'city.editor.tiles': 'Terreno',
  'city.editor.letter': 'Lettera',
  'city.editor.placeName': 'Nome del luogo',
  'city.editor.addPlace': 'Aggiungere spazio',
  'city.editor.placeBad': 'Un posto ha bisogno di una lettera e di un nome.',
  'city.editor.floors': 'Pavimenti',
  'city.editor.addFloor': 'Aggiungere pavimento',
  'city.editor.map': 'Mappa',
  'city.editor.width': 'Larghezza',
  'city.editor.height': 'Altezza',
  'city.editor.new': 'Nuova mappa',
  'city.editor.undo': 'Invalidato',
  'city.editor.export': 'Esportazione',
  'city.editor.import': 'Importazione',
  'city.editor.loaded': 'Mappa caricata.',
  'city.editor.zoom': 'Zoom',
  'city.editor.check': 'Controllo',
  'city.editor.ok': 'Legge bene. {walk} cellule aperte, {reach} accessibile dal punto di partenza.',
  'city.editor.placeSpots': '{name}: {n} cellule',
  'city.editor.canvas': 'Canvas di mappa',
  'city.spy.take': 'Prendila.',
  'city.spy.again': 'Prova di nuovo.',
  'city.spy.drop': 'Lascialo andare.',
  'city.spy.progress': '{n} percentuale lì.',
  'city.spy.carrying': 'Hai il biglietto.',
  'city.spy.underway': 'In arrivo.',
  'city.spy.done': 'E\' finita.',
  'city.spy.failed': 'L\'ultima volta è andata male.',
  'city.menu.look': 'Guardate ! {thing}',
  'city.menu.street': 'La strada',
  'city.menu.wall': 'Un muro',
  'city.continue': 'Continuare',
  'city.goodbye': 'Addio .',
  'city.board.title': 'Tavola di ricompensa',
  'city.arrive.rooftops': 'Si tirano su i tetti, le vie si aprono sotto di loro e le tavole tra le case si crepano sotto i piedi.',
  'city.arrive.museumRoof': 'Si trascina la vecchia ivy sul tetto del museo e Sunwalk Plaza si estende sotto di te come un tavolo da gioco.',
  'city.crier.title': 'Il lenzuolo del grido',
  'city.crier.today': 'Oggi è {name}.',
  'city.crier.tomorrow': '{name} E\' domani.',
  'city.crier.coming': '{name} in {n} Giorni.',
  'city.crier.stalls': 'Sulla banchina al primo sole:',
  'city.crier.notices': '{n} avvisi sulla lavagna delle ricompense.',
  'city.crier.talk': 'Parlando della città:',
  'city.crier.now': 'Sta succedendo in giro per la città in questo momento:',
  'city.board.empty': 'Oggi non c\'e\' niente, controlla domani.',
  'city.board.posted': 'Pubblicato da: {name}.',
  'city.board.postedAt': 'Pubblicato da: {name}, ora a {place}.',
  'city.board.days': '{n} Ci restano giorni.',
  'city.board.find': 'Trovali.',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'Parlando con {name}',
  'city.journal': 'Giornale',
  'city.journalNone': 'Non c\'e\' ancora scritto niente.',
  'city.quests': 'Fabbricazioni di fiocchi',
  'city.questNone': 'Non ancora, parla con la gente.',
  'city.rest': 'Riposo {n} minuti',
  'city.saves.title': 'Giochi salvati',
  'city.saves.slot': 'Scatto {n}: {day} {time}, {place}',
  'city.saves.empty': 'Scatola {n}: vuota',
  'city.saves.save': 'Salva qui.',
  'city.saves.load': 'Carico',
  'city.saves.sure': 'Toccare di nuovo per confermare',
  'city.saves.hint': 'Un salvataggio mantiene l\'intera città in piedi: dove sei, l\'ora, le persone, le missioni e i petti.',
  'city.restHint': 'Lascia passare il tempo, puoi riposare così tanto in un\'ora.',
  'city.bed.ask': 'Dormi dentro. {bed}?',
  'city.bed.night': 'Passano otto ore mentre dormi, e riposi secondo le regole del tuo sistema di gioco.',
  'city.bed.sleep': 'Dormire',
  'city.bed.notNow': 'Non ora.',
  'city.bed.tired': 'Non sei ancora stanca, puoi dormire di nuovo tra poco. {n} - Per ore.',
  'city.bed.asleep': 'Dorme, la notte passa...',
  'city.bed.offer': 'Dormi qui .',
  'city.vitals': 'Salute',
  'city.bed.woke': 'Dormi dentro . {bed} e svegliarsi a {time}. {change}',
  'city.bed.change': '{label}: {before} di {after}.',
  'city.bed.noRest': 'La {system} Le regole non danno guarigione per il riposo, quindi niente si rimedia.',
  'city.bed.beds': 'Letti',
  'city.bed.demoRules': 'Regole per la prova del letto: {system}. Aggiungi "rules=srd-5-2-1, zweihander o ratto" all\'indirizzo per provare un altro.',
  'city.messages': 'Notte',
  'city.rules': 'Sistema di gioco',
  'city.rulesNarrative': 'Nessuna regola: la città come storia, scegli un sistema per vedere tutti nei suoi numeri.',
  'city.statsFor': 'Numeri per',
  'city.sparTitle': 'Combattimento di pratica',
  'city.sparA': 'Primo combattente',
  'city.sparB': 'Secondo combattente',
  'city.sparVs': 'contro',
  'city.sparRun': 'Combattere',
  'city.sparNote': 'Una dimostrazione in questo sistema, nessuno in città è ferito.',
  'city.sparRound': 'Rondo {n}.',
  'city.zoomIn': 'Zoom in',
  'city.pivot.left': 'Ruota la vista a sinistra',
  'city.pivot.right': 'Ruota la vista a destra',
  'city.pivot.north': 'Guarda a nord',
  'city.zoomOut': 'Sballo',
  'city.centre': 'Centrati su di me.',
  'city.followOn': 'Continuate .',
  'city.followOff': 'Seguite.',
  'city.followOnHint': 'La telecamera ti segue.',
  'city.followOffHint': 'Appiccica me per tornare a te stesso.',
  'city.minimapShow': 'Mostra la mappa',
  'city.minimapHide': 'Nascondi la mappa',
  'city.minimapOpen': 'Tocca per aprirlo in modo più grande.',
  'city.minimapWalk': 'Mappa della città, tocca un punto da percorrere.',
  'city.minimapSmall': 'Rimpicciolisci la mappa',
  'city.minimapHint': 'Tocca per camminare.',
  'city.chatter.morning.1.a': 'Pane fresco nei forni d\'angolo, se hai fretta.',
  'city.chatter.morning.1.b': 'Ho sentito l\'odore due strade di là.',
  'city.chatter.morning.2.a': 'Sei sveglio presto.',
  'city.chatter.morning.2.b': 'Le campane mi hanno svegliato.',
  'city.chatter.morning.3.a': 'I carri sono entrati attraverso il cancello?',
  'city.chatter.morning.3.b': 'Tre di loro, e uno ha perso una ruota sul ponte.',
  'city.chatter.morning.4.a': 'Fa freddo stamattina.',
  'city.chatter.morning.4.b': 'La nebbia del fiume brucerà a mezzogiorno.',
  'city.chatter.morning.5.a': 'Dove vai?',
  'city.chatter.morning.5.b': 'Il mercato, prima che le buone mele se ne siano andate.',
  'city.chatter.afternoon.1.a': 'Una giornata impegnativa alle bancarelle.',
  'city.chatter.afternoon.1.b': 'Sono troppo occupato, i miei piedi mi hanno abbandonato.',
  'city.chatter.afternoon.2.a': 'Hai visto il tanner oggi?',
  'city.chatter.afternoon.2.b': 'E\' andato in acqua un\'ora fa.',
  'city.chatter.afternoon.3.a': 'Il sole è buono oggi.',
  'city.chatter.afternoon.3.b': 'La pioggia sta arrivando, la sento in ginocchio.',
  'city.chatter.afternoon.4.a': 'Cosa voleva il pescatore per le anguille?',
  'city.chatter.afternoon.4.b': 'Ho comprato le carote invece.',
  'city.chatter.afternoon.5.a': 'E\' un nuovo carrello?',
  'city.chatter.afternoon.5.b': 'Le ruote urlano ancora come quelle vecchie.',
  'city.chatter.evening.1.a': 'Torni a casa?',
  'city.chatter.evening.1.b': 'La cena non cucina da sola.',
  'city.chatter.evening.2.a': 'Le lampade stanno accendendo.',
  'city.chatter.evening.2.b': 'Allora sono di nuovo in ritardo.',
  'city.chatter.evening.3.a': 'Stasera sarai alla taverna?',
  'city.chatter.evening.3.b': 'Se mia moglie mi permette, sì.',
  'city.chatter.evening.4.a': 'Una lunga giornata.',
  'city.chatter.evening.4.b': 'Tutti lo sono, in questo periodo dell\'anno.',
  'city.chatter.evening.5.a': 'Chiudete le persiane stasera.',
  'city.chatter.evening.5.b': 'Lo faccio sempre, il vento li trema comunque.',
  'city.chatter.night.1.a': 'Chi ci va?',
  'city.chatter.night.1.b': 'Metti giu\' quella lanterna.',
  'city.chatter.night.2.a': 'Dovresti dormire.',
  'city.chatter.night.2.b': 'Anche tu dovresti farlo, amico.',
  'city.chatter.night.3.a': 'Hai sentito qualcosa vicino all\'acqua?',
  'city.chatter.night.3.b': 'I gatti, sono sempre gatti.',
  'city.chatter.night.4.a': 'Una notte tranquilla.',
  'city.chatter.night.4.b': '- Non lo faremo mai.',
  'city.chatter.any.1.a': 'Hai sentito le notizie?',
  'city.chatter.any.1.b': '- Ci sono sempre notizie.',
  'city.chatter.any.2.a': 'Buona giornata.',
  'city.chatter.any.2.b': 'E anche a te.',
  'city.chatter.any.3.a': 'Mio cugino giura che la vecchia torre è infestata.',
  'city.chatter.any.3.b': 'Il tuo cugino giura molte cose.',
  'city.chatter.any.4.a': 'I prezzi continuano ad aumentare.',
  'city.chatter.any.4.b': 'E il mio stipendio continua a fermarsi.',
  'city.chatter.any.5.a': 'Attenzione alla ciotola.',
  'city.chatter.any.5.b': 'Troppo tardi, grazie comunque.',
  'city.chatter.any.6.a': 'E\' questo lo straniero di cui tutti parlano?',
  'city.chatter.any.6.b': 'Non fissare, e\' scortese.',
  'city.chatter.any.7.a': 'Come sta tua madre?',
  'city.chatter.any.7.b': 'Meglio, grazie, e\' tornata a rimproverarmi.',
  'city.chatter.any.8.a': 'Ti devo un drink, vero?',
  'city.chatter.any.8.b': 'Due, secondo il mio conto.',
  'city.inventory.title': 'Il tuo pacco',
  'city.inventory.subtitle': 'Montkelian sacchetta',
  'city.inventory.close': 'Chiudi la valigia',
  'city.inventory.tabs': 'Sezioni di imballaggio',
  'city.inventory.tab.inventory': 'Inventario',
  'city.inventory.tab.journal': 'Giornale',
  'city.inventory.tab.map': 'Mappa',
  'city.inventory.empty': 'Le cose che troverai durante i tuoi viaggi saranno in queste tasche.',
  'city.inventory.slots': 'Tasche',
  'city.inventory.slotEmpty': 'Pocket {n}, vuoto',
  'city.inventory.slot.headgear': 'Cappello di testa',
  'city.inventory.slot.helmet': 'Casco',
  'city.inventory.slot.hat': 'Cappello',
  'city.inventory.slot.hood': 'Cappuccio',
  'city.inventory.slot.amulet': 'Amuleto',
  'city.inventory.slot.cloak': 'Mantello',
  'city.inventory.slot.tabard': 'Tabardo',
  'city.inventory.slot.pelt': 'Pelle',
  'city.inventory.slot.armor': 'Armatura',
  'city.inventory.slot.plate': 'Piatto',
  'city.inventory.slot.robe': 'Robe',
  'city.inventory.slot.jerkin': '- Che cretino.',
  'city.inventory.slot.hide': 'Nascondetevi',
  'city.inventory.slot.girdle': 'Girdle',
  'city.inventory.slot.belt': 'Cintura',
  'city.inventory.slot.bracers': 'Fabbricazioni',
  'city.inventory.slot.gloves': 'Guanti',
  'city.inventory.slot.mainHand': 'Main hand',
  'city.inventory.slot.offHand': '- Non c\'e\' bisogno.',
  'city.inventory.slot.twoHand': 'Entrambe le mani.',
  'city.inventory.slot.sword': 'La spada',
  'city.inventory.slot.shield': 'Scudo',
  'city.inventory.slot.staff': 'Personale',
  'city.inventory.slot.focus': 'Concentrati',
  'city.inventory.slot.ring': 'Anello',
  'city.inventory.slot.leggings': 'Leggings',
  'city.inventory.slot.greaves': 'Greaves',
  'city.inventory.slot.boots': 'Scalza',
  'city.inventory.item.sword': 'La spada',
  'city.inventory.item.shield': 'Scudo',
  'city.inventory.item.knife': 'Coltello',
  'city.inventory.item.axe': 'Axe',
  'city.inventory.item.tabard': 'Tabardo',
  'city.inventory.item.cape': 'Capo',
  'city.inventory.item.ring': 'Anello',
  'city.inventory.class.default': 'viaggiatore',
  'city.inventory.class.fighter': 'combattente',
  'city.inventory.class.paladin': 'paladino',
  'city.inventory.class.berserker': 'Berserker',
  'city.inventory.class.wizard': 'magico',
  'city.inventory.class.rogue': 'il malvagio',
  'city.inventory.slotFree': 'Vaga',
  'city.inventory.gear': 'Cosa indossi ?',
  'city.inventory.view': 'Spettacolo',
  'city.inventory.viewGear': 'Indossato',
  'city.inventory.viewPockets': 'Tasche',
  'city.inventory.avatarHint': 'Scegli un altro avatar dal menu, sotto Avatar.',
  'city.inventory.soon.journal': 'Per ora il suo diario è vuoto, le ricerche e le note raccolte saranno scritte qui.',
  'city.inventory.soon.map': 'La tua mappa piegata sarà conservata qui, contrassegnata con i luoghi in cui sei stato.',
  'city.inventory.hint': 'Colpisci per aprire la valigia',
  'city.avatar': 'Avatar',
  'city.avatarLabel': 'Scegli il tuo avatar',
  'city.avatar.robot': 'Robot',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Paladino',
  'city.avatarCloth': 'Indumenti',
  'city.avatarClothHint': 'Capes e tabards oscillare mentre si muove',
  'city.soundOn': 'Accendi il suono',
  'city.soundOff': 'Spegni il suono',
  'city.musicOn': 'Suona musica',
  'city.musicOff': 'Fermate la musica .',
  'city.walkSpeed': 'Velocità',
  'city.walkSpeedLabel': 'Velocità di camminata',
  'city.walkSpeedValue': '{n}x',
  'city.me': '- Io',
  'city.quality': 'Qualità',
  'city.qualityAuto': 'Auto ({tier})',
  'city.tier.low': 'Basso',
  'city.tier.medium': 'Medium',
  'city.tier.high': 'Alti',
  'city.robot.keys': 'Teste di robot',
  'city.robot.title': 'Teste di robot',
  'city.robot.intro': 'Presi un tasto, o tocchi qui, e il tuo robot lo fa vedere a tutti i vicini.',
  'city.robot.close': 'Chiuso',
  'city.robot.jumpNote': 'Presi Spazio di nuovo mentre sei in aria per fare il doppio salto.',
  'city.robot.spellNote': 'In modalità incantesimo, 1, 2 e 3 lanciano invece di attaccare.',
  'city.robot.climbNote': 'Pagina su e pagina giù salire le scale, scala, ivy o drenaio più vicino a te.',
  'city.robot.walkNote': 'W, A, S e D camminano a nord, ovest, sud e est passo dopo passo.',
  'city.robot.walk.north': 'Camminare a nord',
  'city.robot.walk.west': 'Camminare a ovest',
  'city.robot.walk.south': 'Camminare a sud',
  'city.robot.walk.east': 'Camminare ad est',
  'city.stairs.label': 'Prendi le scale .',
  'city.stairs.up': 'Alzati',
  'city.stairs.down': 'A terra.',
  'city.stairs.goUp': 'Sali un piano .',
  'city.stairs.goDown': 'Scendi da un piano .',
  'city.robot.toggleNote': 'La modalità arma, la modalità incantesimo, Sneak, Dance e Fall down restano in funzione fino a quando non li premete di nuovo.',
  'city.robot.typing': 'Le chiavi non fanno nulla mentre scrivi in una scatola.',
  'city.robot.inSpell': 'Modalità di incantesimo: {act}',
  'city.robot.otherwise': 'Altrimenti: {act}',
  'city.robot.pad': 'Azioni',
  'city.robot.padShow': 'Visualizza la scheda di azione',
  'city.robot.padHide': 'Nascondere la scheda d\' azione',
  'city.robot.padTouch': '(per i touch screen)',
  'city.robot.noLadder': 'Nessuna scalinata o scala vicino',
  'city.robot.act.jump': 'Salta .',
  'city.robot.act.double-jump': 'Salto doppio',
  'city.robot.act.dodge': '- Non farlo .',
  'city.robot.act.block': 'Bloccare o difendere',
  'city.robot.act.parry': 'Parry',
  'city.robot.act.weapon-mode': 'Modalità di arma',
  'city.robot.act.spell-mode': 'Modalità di incantesimo',
  'city.robot.act.slash': 'Slash',
  'city.robot.act.thrust': 'Spinta',
  'city.robot.act.flurry': '- Furioso .',
  'city.robot.act.cast': 'Casting',
  'city.robot.act.cast-spell': 'Incantesimo di lancio',
  'city.robot.act.megacast': 'Megacast',
  'city.robot.act.duck': 'Anca.',
  'city.robot.act.sneak': 'Sneak',
  'city.robot.act.sing': 'Cantate',
  'city.robot.act.dance': 'Danza .',
  'city.robot.act.barf': 'Fabbricazione',
  'city.robot.act.fall': 'Cadere o alzarsi',
  'city.robot.act.climb-up': 'Sali su.',
  'city.robot.act.climb-down': 'Scendi .',
  'city.robot.act.hurt': 'Prendi un colpo .',
  'city.robot.act.kneel': 'In ginocchio e in piedi',
  'city.robot.act.bow': 'Arco',
  'city.robot.act.cheer': 'Auguri per la vittoria',
  'city.panelShow': 'Pannello di visualizzazione',
  'city.phone.menu': 'Menù',
  'city.phone.close': 'Menù di chiusura',
  'city.phone.view': 'Mappa',
  'city.phone.sound': 'Suono e ritmo',
  'city.phone.people': 'Trova qualcuno .',
  'city.phone.more': 'Tutto il resto .',
  'city.phone.hint': 'Colpisci la terra per camminare, colpisci una persona per parlare.',
  'city.phone.gotIt': 'Ho capito.',
  'city.panelHide': 'Pannello nascosto',
  'city.canvasLabel3d': 'Mappa di {city} La scheda mostra tutti e tutto anche qui.',
  'city.dock.label': 'Persone da trovare',
  'city.dock.go': 'Passeggiate . {name}',
  'city.dock.walking': 'A piedi {name}',
  'city.dock.toPlace': 'A piedi {name} in {place}',
  'city.dock.cancel': 'Colpisci il terreno per fermarti',
  'city.rigDebug.open': 'Debug come {name} movimenti',
  'city.rigDebug.title': 'Debug del macchinario: {name}',
  'city.rigDebug.close': 'Chiuso',
  'city.rigDebug.move': 'Muovetevi',
  'city.rigDebug.facing': 'Di fronte',
  'city.rigDebug.allMoves': 'Tutti i movimenti',
  'city.rigDebug.allFacings': 'Tutte le facce',
  'city.rigDebug.cycling': 'Ciclismo, {s} ciascuno',
  'city.rigDebug.play': 'Giocare',
  'city.rigDebug.pause': 'Pausa',
  'city.rigDebug.back': 'Un passo indietro.',
  'city.rigDebug.forward': 'Un passo avanti, un quadro.',
  'city.rigDebug.speed': 'Velocità',
  'city.rigDebug.hint': 'Fare una pausa, passo dopo passo, toccare fuori o premere Escape per chiudere.',
  'city.rigDebug.anim.idle': 'Odio',
  'city.rigDebug.anim.walk': 'Camminare',
  'city.rigDebug.debug': 'Debug',
  'city.rigDebug.viewLabel': 'Vista',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Isometrici',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'di fronte a {dir}',
  'city.rigDebug.cell': 'Righe {row}, cornice {col}',
  'city.rigDebug.loading': 'carico',
  'city.rigDebug.clip': 'Clip',
  'city.rigDebug.allClips': 'Tutte le clip',
  'city.rigDebug.noClips': 'Nessun clip',
  'city.rigDebug.layers': 'Spettacolo',
  'city.rigDebug.show.model': 'Modello',
  'city.rigDebug.show.bones': 'Ossa',
  'city.rigDebug.show.pieces': 'Fabbricazioni',
  'city.rigDebug.boneCount': '{n} ossa',
  'city.rigDebug.no3d': 'La visualizzazione 3D non poteva iniziare su questo schermo.',
  'city.rigDebug.hint3d': 'Trascinate per girare la fotocamera, fate una pausa passo dopo passo, toccate fuori o premete Escape per chiudere.',
  'city.rigDebug.standIn': '{name} è indicato sul {body} Il corpo qui finche\' il suo non e\' pronto.',
  'city.rigDebug.archive': 'Archivi',
  'city.rigDebug.archivePose': 'Preview della posa: vedere come {name} movimenti',
  'city.pose.open': 'Vediamo come {name} movimenti',
  'city.pose.robot': 'Tu (robot sostitutivo)',
  'city.pose.you': 'Tu ...',
  'city.pose.see': 'Guardali muoversi .',
  'city.pose.youTitle': 'Come ti muovi',
  'city.pose.openYou': 'Guarda come ti muovi .',
  'city.pose.title': 'Come {name} movimenti',
  'city.pose.allTitle': 'Tutte le posizioni',
  'city.pose.all': 'Mostra tutte le posizioni',
  'city.pose.one': 'Solo che... {name}',
  'city.pose.close': 'Chiuso',
  'city.pose.hint': 'Tocca fuori per chiudere',
  'city.pose.loading': 'Caricamento',
  'city.pose.anim.idle': 'Odio',
  'city.pose.anim.walk': 'Camminare',
  'city.pose.anim.talk': 'Parla',
  'city.pose.anim.sit': 'Sedetevi.',
  'city.pose.anim.run': 'Corri .',
  'city.pose.drag': 'Trascinare per girare',
  'city.pose.gait': 'Movimento',
  'city.pose.model': '{name} in 3D',
  'city.pose.dir.SW': 'rivolto a sud-ovest',
  'city.pose.dir.SE': 'rivolto a sud-est',
  'city.pose.dir.NE': 'rivolto a nord-est',
  'city.pose.dir.NW': 'rivolto a nord-ovest',
  'city.demoLink': 'Apri la demo del renderer',
  'city.demoTitle': 'Demo del renderer',
  'city.demoNote': 'Una preview locale della città 3D con i passeggeri in stand-in.',
  'city.demoTime': 'Orario della giornata',
  'city.demoSeason': 'Stagione',
  'city.demoPlay': 'Fate girare l\' orologio .',
  'city.demoPause': 'Ferma l\' orologio .',
  'city.demoTower': 'Torri di prova',
  'city.demoTowerNote': 'Un edificio di quattro piani per controllare ciò che si può vedere all\'interno. all\'interno, i piani sopra di voi sono tagliati e tutto ciò che non si può vedere da dove si trova è grisgiato.',
  'city.demoGoTower': 'Cammina alla torre',
  'city.demoFloor': 'Piano: {floor}',
  'city.demoFloor0': 'Terreno',
  'city.demoFloor1': '2°',
  'city.demoFloor2': 'Terzo',
  'city.demoFloor3': 'Quarto',
  'city.demoFloor4': 'Scaffo',
  'city.demoWindow': 'Finestra del terzo piano',
  'city.demoRoom': 'Quartiere interiore al terzo piano',
  'city.demoUp': 'Su un piano .',
  'city.demoDown': 'Sotto un pavimento .',
  'city.makeWay.polite': 'Oh, scusami.',
  'city.makeWay.gruff': 'Ehi, guardati dove cammini.',
  'city.makeWay.immovable': 'Non mi muovo.',
  'city.makeWay.busy': 'Attenzione.',
  'cascade.seoTitle': 'Cascade Debugger',
  'cascade.title': 'Cascade Debugger',
  'cascade.intro': 'Il lato stile va dal sistema fino al direttore artistico. Il lato ereditario è l\'intera tassonomia, da ogni radice di frammento fino alle specie e alle linee che si siedono su di loro. Apri qualsiasi riga per leggere il suo testo completo.',
  'cascade.readOnly': 'Niente su questo schermo può cambiare un prompt.',
  'cascade.fetchedAt': 'Leggere dall\'API di contenuti a {time}',
  'cascade.refresh': 'Leggi di nuovo',
  'cascade.loading': 'Leggendo entrambe le cascate...',
  'cascade.error': 'Non riuscivo a leggere le cascate dell\'API dei contenuti.',
  'cascade.forbidden': 'Questo schermo è per gli amministratori del sito. Il tuo account è connesso ma non ha il ruolo di amministratore.',
  'cascade.style.title': 'Cascata di stili',
  'cascade.style.subtitle': 'Sistema, editore, linea di prodotti, impostazione, tipo di supporto, libro e direttore artistico.',
  'cascade.style.focus': 'Seguire la catena per',
  'cascade.style.counts': '{nodes} linee di stile, {edges} connessioni, {media} modelli multimediali',
  'cascade.taxa.title': 'Cascata degli eredi',
  'cascade.taxa.subtitle': 'Ogni nodo aggiunge il proprio prompt a tutto quello che eredita dai nodi sopra di esso.',
  'cascade.taxa.group': 'Gruppo immediato',
  'cascade.taxa.find': 'Trovare un taxone o una stirpe',
  'cascade.taxa.findPlaceholder': 'Homo, Terrana, un nome di stirpe...',
  'cascade.taxa.counts': '{taxa} tassi, {prompts} tasson prompts, {lineages} lineages',
  'cascade.taxa.shardCounts': '{taxa} tassi, {prompts} richiede file',
  'cascade.taxa.truncated': 'L\'API dei contenuti ha limitato la lista di richieste di questo shard, quindi alcune righe potrebbero mancare qui.',
  'cascade.taxa.emptyShards': 'Schemi senza ancora tassi: {names}',
  'cascade.taxa.orphans': 'Le linee che puntano su un taxone che non si trova in nessun albero',
  'cascade.taxa.noOwn': 'Nessun richiamo per questo gruppo.',
  'cascade.taxa.inherits': 'Ereditari dall\'alto',
  'cascade.taxa.inheritsNothing': 'Niente di ereditato, è qui che inizia la catena.',
  'cascade.taxa.through': 'Composto attraverso questo nodo',
  'cascade.taxa.lineages': 'Le linee di questa specie',
  'cascade.level.system': 'Sistema',
  'cascade.level.publisher': 'Pubblico',
  'cascade.level.product_line': 'Linea di prodotti',
  'cascade.level.setting': 'Impostazione',
  'cascade.level.media': 'Tipo di supporto',
  'cascade.level.book': 'Libro',
  'cascade.level.art_director': 'Direttore artistico',
  'cascade.empty.system': 'Nessuna riga di stile di sistema su questa catena.',
  'cascade.empty.publisher': 'Non c\'è ancora una linea di stile editoriale, questo livello è vuoto.',
  'cascade.empty.product_line': 'Nessuna riga di stile della linea di prodotto in questa catena.',
  'cascade.empty.setting': 'Nessuna riga di stile su questa catena.',
  'cascade.empty.media': 'Nessun modello di tipo media si applica a questa catena.',
  'cascade.empty.book': 'Nessuna riga di stile libro dipende da questa impostazione.',
  'cascade.empty.art_director': 'Nessun direttore artistico è collegato a questa catena.',
  'cascade.missing': 'Livello mancante',
  'cascade.others': 'Altre righe a questo livello ({count})',
  'cascade.mediaSpeciesNote': '{count} I modelli delle specie sono mostrati sul lato ereditario, sotto le loro linee.',
  'cascade.field.id': 'id',
  'cascade.field.scope': 'portata',
  'cascade.field.scopeId': 'id di campo di applicazione',
  'cascade.field.group': 'gruppo',
  'cascade.field.mediaType': 'tipo di supporto',
  'cascade.field.prompt': 'Pronto',
  'cascade.field.negative': 'negativo',
  'cascade.field.defaults': 'di default',
  'cascade.field.refs': 'immagini di riferimento',
  'cascade.field.chars': '{count} caratteri',
  'cascade.field.empty': 'vuoto',
  'cascade.facet.art_direction': 'Il nucleo',
  'cascade.facet.art_direction_character': 'Caratterismo',
  'cascade.facet.art_direction_scene': 'Scena',
  'cascade.facet.art_direction_interface': 'Interfaccia',
  'cascade.facet.art_direction_cartography': 'Cartografia',
  'cascade.facet.art_direction_audiobook': 'Libro audio',
  'cascade.facet.art_direction_movie': 'Film',
  'cascade.facet.art_direction_short': 'Brevi',
  'cascade.facet.art_direction_tvshow': 'Spettacolo televisivo',
  'cascade.composed.title': 'Composta per: {name}',
  'cascade.composed.layers': 'Strati, da larghi a stretti',
  'cascade.composed.preview': 'Impressione composta',
  'cascade.composed.previewNote': 'Assemblato su questo schermo dalle righe sopra in ordine di cascata: stile core, carattere facciata, modelli multimediali, tratti di tasson, poi la linea di stampa il generatore aggiunge in codice.',
  'cascade.composed.negative': 'Negativo composto',
  'cascade.composed.fromCode': 'aggiunto in codice, non conservato in nessuna riga',
  'cascade.flags.duplicates': 'Ho detto due volte.',
  'cascade.flags.conflicts': 'Termini negativi che appaiono anche nel prompt',
  'cascade.flags.none': 'Niente frasi ripetute e termini negativi che contraddicano l\'invito.',
  'cascade.flags.in': 'in {sources}',
  'cascade.source.styleCore': 'core di stile',
  'cascade.source.styleCharacter': 'facce di carattere di stile',
  'cascade.source.media': 'modello multimediale, {scope}',
  'cascade.source.taxon': 'taxone {rank} {value}',
  'cascade.source.printSafe': 'linea di stampa (codice)',
  'cascade.rank.domain': 'dominio',
  'cascade.rank.kingdom': 'regno',
  'cascade.rank.phylum': 'Filo',
  'cascade.rank.class': 'classe',
  'cascade.rank.ordem': 'Ordine',
  'cascade.rank.family': 'famiglia',
  'cascade.rank.genus': 'genere',
  'cascade.rank.species': 'specie',
  'cascade.rank.shard': 'frammento',
}
